import { useTranslation } from 'next-i18next'
import React from 'react'
import { BasicUser } from '../../types/userTypes'
import Button from '../../ui/buttons/button'
import ReactModal from '../../ui/Modal/ReactModal'
import { useAuthenticatedRequest } from '../../modules/api/hooks'

const BlockModal = ({
  user,
  onClose,
}: {
  user: BasicUser
  onClose: () => void
}) => {
  const request = useAuthenticatedRequest()
  const handleBlock = () =>
    request('POST', `/api/block/user/${user.id}`).then(
      () => (document.location.href = '/')
    )

  const { t } = useTranslation('common')

  return (
    <ReactModal
      isOpen={true}
      shouldDisplayCloseButton
      onRequestClose={onClose}
      size="small"
    >
      <div className="pad--base">
        <h2>{t('block_user.title', { name: user.name })}</h2>
        <p>{t('block_user.description', { name: user.name })}</p>
        <Button wide onClick={onClose}>
          {t('block_user.cancel_button_label')}
        </Button>
        {request ? (
          <Button wide danger onClick={handleBlock} className="pull-right">
            {t('block_user.block_button_label')}
          </Button>
        ) : (
          <span>Loading</span>
        )}
      </div>
    </ReactModal>
  )
}

export default BlockModal
